import React from 'react';

// full: centers the spinner in a min-height block, good for a whole page/section.
// inline: just the spinner, for dropping inside a card or button-sized space.
export default function Loader({ full = true, label }) {
  const spinner = <span className="spinner" aria-hidden="true" />;

  if (!full) {
    return spinner;
  }

  return (
    <div className="loader-block">
      {spinner}
      {label && <p className="loader-label">{label}</p>}
    </div>
  );
}
